module.exports = __webpack_public_path__ + "img/background-todos-mobile.f0b90733.jpg";